module.exports = __webpack_public_path__ + "media/images/donation/mobile-megaphone-a61b7e8942363bf4b2c5d44e6a12cac7.svg";